import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=eb2926a8&scoped=true"
import script from "./IconFont.vue?vue&type=script&lang=js"
export * from "./IconFont.vue?vue&type=script&lang=js"
import style0 from "./IconFont.vue?vue&type=style&index=0&id=eb2926a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2926a8",
  null
  
)

export default component.exports